<script setup lang="ts">
import { useCoverImage } from '../../../composables/use-cover-image'

const { coverImageUrl } = useCoverImage()
</script>

<template>
  <div class="bx-footer__abo-teaser bx-form bx-typo--form">
    <div class="bx-footer__abo-teaser-image">
      <img :src="coverImageUrl('autozeitung', 150)"
           width="2"
           height="3"
           loading="lazy">
    </div>
    <div class="bx-footer__abo-teaser-inner-wrapper">
      <span class="bx-footer__abo-teaser-headline">
        AUTO ZEITUNG im Abo
      </span>
      <span class="bx-footer__abo-teaser-roofline">
        Erscheint 14-täglich
      </span>
      <a
        target="_blank"
        rel="noopener"
        href="https://www.bauer-plus.de/autozeitung/">
        <button class="bx-form__button">
          Abonnieren
        </button>
      </a>
    </div>
  </div>
</template>
